if (!customElements.get('cart-cross-sell')) {
  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-cart-cross-sell-slider]');
      this.previousButton = this.querySelector('[data-cart-cross-sell-previous]');
      this.nextButton = this.querySelector('[data-cart-cross-sell-next]');

      if (!this.slider || !this.previousButton || !this.nextButton) return;

      this.onPrevClick = () => this.scrollSlider(-1);
      this.onNextClick = () => this.scrollSlider(1);
      this.onScroll = () => this.updateButtons();
      this.onResize = () => this.updateButtons();

      this.previousButton.addEventListener('click', this.onPrevClick);
      this.nextButton.addEventListener('click', this.onNextClick);
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.slider);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if (typeof IntersectionObserver !== 'undefined') {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.updateButtons();
          }
        });
        this.intersectionObserver.observe(this);
      }

      const drawer = this.closest('theme-drawer, dialog, cart-drawer-component, .theme-drawer__dialog');
      if (drawer) {
        this.drawerListener = () => this.updateButtons();
        drawer.addEventListener('theme-drawer:open', this.drawerListener);
        drawer.addEventListener('transitionend', this.drawerListener);
        drawer.addEventListener('animationend', this.drawerListener);
      }

      const images = this.slider.querySelectorAll('img');
      images.forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', this.onResize, { once: true });
        }
      });

      this.updateButtons();
      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      if (this.previousButton && this.onPrevClick) {
        this.previousButton.removeEventListener('click', this.onPrevClick);
      }
      if (this.nextButton && this.onNextClick) {
        this.nextButton.removeEventListener('click', this.onNextClick);
      }
      if (this.slider && this.onScroll) {
        this.slider.removeEventListener('scroll', this.onScroll);
      }
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame);
      }
      if (this.drawerListener) {
        const drawer = this.closest('theme-drawer, dialog, cart-drawer-component, .theme-drawer__dialog');
        if (drawer) {
          drawer.removeEventListener('theme-drawer:open', this.drawerListener);
          drawer.removeEventListener('transitionend', this.drawerListener);
          drawer.removeEventListener('animationend', this.drawerListener);
        }
      }
    }

    scrollSlider(direction) {
      const firstCard = this.slider.querySelector('.cart-cross-sell__card');
      if (!firstCard) return;

      const cardWidth = firstCard.getBoundingClientRect().width;
      const style = window.getComputedStyle(this.slider);
      const gap = parseFloat(style.columnGap || style.gap) || 12;
      const distance = direction * (cardWidth + gap);

      const current = this.slider.scrollLeft;
      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      const target = Math.max(0, Math.min(current + distance, maxScroll));

      if (Math.abs(target - current) < 1) return;

      this.slider.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if (!this.slider || !this.previousButton || !this.nextButton) return;

      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      const currentScroll = Math.abs(this.slider.scrollLeft);
      const isOverflowing = this.slider.scrollWidth > this.slider.clientWidth + 2;

      this.previousButton.disabled = currentScroll <= 2;
      this.nextButton.disabled = currentScroll >= maxScroll - 2;

      this.previousButton.hidden = !isOverflowing;
      this.nextButton.hidden = !isOverflowing;
    }
  }

  customElements.define('cart-cross-sell', CartCrossSell);
}
